export default "__VITE_PUBLIC_ASSET__53f5e131__"